"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationOptions = void 0;
/**
 * ValidationOptions are a configuration object used to setup validators.
 *
 * @class ValidationOptions
 */
class ValidationOptions {
    constructor(errorFactory, validationResultFactory) {
        this.errorFactory = errorFactory;
        this.validationResultFactory = validationResultFactory;
    }
}
exports.ValidationOptions = ValidationOptions;
